/** Simulation x-right/y-down => Three X-right/Z-south, Y is visual height. */
export function worldPosition(x: number, y: number, height = 0): [number, number, number] {
  return [x, height, y];
}

/** A normalized model/plane faces local -Z. Simulation heading increases eastward. */
export function worldYaw(headingRad: number): number {
  return -headingRad;
}

/** Matches Phaser's zoom-aware scroll clamp; returned center is in map pixels. */
export function clampCameraScroll(
  scroll: number,
  viewport: number,
  extent: number,
  zoom: number,
): number {
  const visible = viewport / zoom;
  if (visible > extent) return extent / 2 - viewport / 2;
  const minimum = (visible - viewport) / 2;
  return Math.max(minimum, Math.min(minimum + extent - visible, scroll));
}
